/* eslint-disable */
import { DgtNavigationItem } from 'app/core/navigation/navigation.types';

export const defaultNavigation: DgtNavigationItem[] = [
    {
        id   : 'users',
        title: 'Usuários',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/admin/users',
        permitions: ['super-admin']
    },
    {
        id   : 'roles',
        title: 'Niveis',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/admin/roles',
        permitions: ['super-admin']
    },
    {
        id   : 'applications',
        title: 'Aplicações',
        type : 'basic',
        icon : 'heroicons_outline:window',
        link : '/admin/applications',
        permitions: ['super-admin']
    },
    {
        id   : 'clients',
        title: 'Clientes',
        type : 'basic',
        icon : 'heroicons_outline:building-office',
        link : '/admin/clients',
        permitions: ['super-admin']
    },
    {
        id   : 'clients-applications',
        title: 'Acessos',
        type : 'basic',
        icon : 'heroicons_outline:key',
        link : '/admin/clients-applications',
        permitions: ['super-admin']
    },
    {
        id   : 'permissions',
        title: 'Permissões',
        type : 'basic',
        icon : 'heroicons_outline:identification',
        link : '/admin/permissions',
        permitions: ['super-admin']
    },
    {
        id: 'audits',
        title: 'Auditoria',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/audits',
        permitions: ['super-admin']
    },
    {
        id: 'sessions',
        title: 'Sessões',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/sessions',
        permitions: ['super-admin']
    },
    {
        id: 'enterprise',
        title: 'Empresa',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/enterprise',
        permitions: ['super-admin', 'client-admin']
    },
    {
        id: 'licenses',
        title: 'Licenças',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/licenses',
        permitions: ['super-admin']
    },
    {
        id   : 'profile',
        title: 'Perfil',
        type : 'basic',
        icon : 'heroicons_outline:user-circle',
        link : '/profile'
    }
];

export const compactNavigation: DgtNavigationItem[] = [
    {
        id   : 'users',
        title: 'Usuários',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/admin/users',
        permitions: ['super-admin']
    },
    {
        id   : 'roles',
        title: 'Niveis',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/admin/roles',
        permitions: ['super-admin']
    },
    {
        id   : 'applications',
        title: 'Aplicações',
        type : 'basic',
        icon : 'heroicons_outline:window',
        link : '/admin/applications',
        permitions: ['super-admin']
    },
    {
        id   : 'clients',
        title: 'Clientes',
        type : 'basic',
        icon : 'heroicons_outline:building-office',
        link : '/admin/clients',
        permitions: ['super-admin']
    },
    {
        id   : 'clients-applications',
        title: 'Acessos',
        type : 'basic',
        icon : 'heroicons_outline:key',
        link : '/admin/clients-applications',
        permitions: ['super-admin']
    },
    {
        id   : 'permissions',
        title: 'Permissões',
        type : 'basic',
        icon : 'heroicons_outline:identification',
        link : '/admin/permissions',
        permitions: ['super-admin']
    },
    {
        id: 'audit',
        title: 'Relatórios',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/audits',
        permitions: ['super-admin']
    },
    {
        id: 'sessions',
        title: 'Sessões',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/sessions',
        permitions: ['super-admin']
    },
    {
        id: 'enterprise',
        title: 'Empresa',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/enterprise',
        permitions: ['super-admin', 'client-admin']
    },
    {
        id: 'licenses',
        title: 'Licenças',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/admin/licenses',
        permitions: ['super-admin']
    },
    {
        id   : 'profile',
        title: 'Perfil',
        type : 'basic',
        icon : 'heroicons_outline:user-circle',
        link : '/profile'
        // Sem permitions = visível para todos
    }
];